import { ChangeEvent } from 'react'

import { Col, Span } from 'components'
import { COLORS } from 'utils'

import {
  InputLabelStyled,
  MenuItemStyled,
  SelectStyled,
  SelectStyles
} from './styles'

interface SelectProps extends SelectStyles {
  register?: any
  errors?: any
  required?: boolean
  formValue?: string
  label?: string
  value?: string | number
  clearSelectValue?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  listOptions: any[]
  disableUnderline?: boolean
  placeholder?: string
  defaultPlaceholderValue?: string | number
  defaultValue?: string | number
  labelMenu?: string
  valueMenu?: string | number
  disabled?: boolean
  clearSelect?: boolean
  customError?: boolean
  hidden?: boolean
}

const Select = ({
  formValue,
  label = '\u00A0',
  value = 'none',
  onChange,
  errors,
  customError,
  marginTop,
  defaultPlaceholderValue = 'none',
  marginBottom,
  marginLeft,
  marginRight,
  listOptions,
  disableUnderline = false,
  placeholder,
  clearSelect,
  width,
  defaultValue,
  labelMenu = 'label',
  valueMenu = 'value',
  disabled,
  hidden = false,
}: SelectProps) => {
  const formatLabel = () => label?.charAt(0).toUpperCase() + label?.slice(1)
  const hasError = (errors && errors[formValue]) || customError
  const styleSelecione = clearSelect ? { cursor: 'pointer', opacity: 0.38 } : {}
  return (
    <Col
      marginTop={marginTop}
      marginRight={marginRight}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
    >
      <InputLabelStyled hasError={hasError}>{hidden ? '' : formatLabel()}</InputLabelStyled>
      <SelectStyled
        disabled={disabled}
        name={formValue}
        placeholder={placeholder}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
        variant="standard"
        disableUnderline={disableUnderline}
        width={width}
        error={hasError}
        hidden={hidden}
      >
        <MenuItemStyled
          value={defaultPlaceholderValue}
          disabled={clearSelect ? false : true}
          style={styleSelecione}
        >
          {placeholder || 'Selecione'}
        </MenuItemStyled>
        {listOptions?.length > 0 &&
          listOptions?.map((item, index) => (
            <MenuItemStyled
              value={item && valueMenu && item[valueMenu] !== undefined ? item[valueMenu] : item}
              key={`${index}-option`}
            >
              {item && labelMenu && item[labelMenu] !== undefined ? item[labelMenu] : item}
            </MenuItemStyled>
          ))}
      </SelectStyled>
      {hasError && <Span text="Campo obrigatório" color={COLORS.error} />}
    </Col>
  )
}

export default Select
